export const tourAttachments = (state) => state.attachments;
